import _ from 'lodash'

export default ({
  debouncePeriodInSeconds,
  ...rest
}) => ({
  debouncePeriodInSeconds: _.toNumber(debouncePeriodInSeconds),
  ...rest
})
